import React, { FC, ReactNode } from 'react';
import { FormLayout as FormLayoutCore } from 'ia-react-core';
import { NeedHelp } from 'aw-package-react-authentication';
import { getHomePageUrl } from '~/utils/urlUtils';
import { useTranslation } from 'react-i18next';
import { getHostName } from 'omni-package-react-cms';
import getSitecorePath from '~/utils/getSitecorePath';
import splashImg from './assets/background.jpg';

export interface FormLayoutProps {
  children: ReactNode;
}

const FormLayout: FC<FormLayoutProps> = ({ children }) => {
  const footerUrl = getSitecorePath('global/footers/footer non-authenticated', true, '/api/ssc/aggregate/content/Items/footer/');
  const sitecorePath = getHostName();
  const { t } = useTranslation('App');

  return (
    <FormLayoutCore
      noFooterLanguageButton={false}
      mainFooterLinksUrl={footerUrl}
      mainFooterLinksDomain={`${sitecorePath}/cw`}
      noHeaderLanguageButton
      contentBackground={`url(${splashImg})`}
      contentBackgroundRepeat="no"
      contentBackgroundPosition="50% 50%"
      contentBackgroundAttachment="fixed"
      homePageUrl={getHomePageUrl()}
      copyrightText={t('copyright')}
    >
      <FormLayoutCore.MainHeaderRightContent>
        <NeedHelp />
      </FormLayoutCore.MainHeaderRightContent>
      {children}
    </FormLayoutCore>
  );
};

export default FormLayout;
